import { KEY_IN_GRAPHQL_CUSTOM_FILTER } from '~~/constants/commerceTools';
export const limitByKeysCustomerFilter = (keyList: string[]) => {

  return KEY_IN_GRAPHQL_CUSTOM_FILTER.replace(':KEY_LIST', keyList.join(','));

};
